export default __webpack_public_path__ + "static/Wideangle_Lense_2.2mm_Angle_of_View-f5a9b1e0af3a12d61a31c2baa631f84f.webp";